import React, { ReactNode } from 'react';
import { useParams } from 'react-router';
import { SalesforceIntegrationId } from 'api/integrations';
import { ReactComponent as SalesforceLogo } from 'assets/svgs/salesforce-logo.svg';
import { Page } from 'components/molecules/page';
import {
  IntegrationHeader,
  PageContent,
} from 'components/organisms/module-settings/integrations/components';
import { NavigationTabs } from 'components/organisms/module-settings/integrations/integrations-list/salesforce/navigation';
import { useTranslation } from 'hooks/use-translation';
import { IntegrationStatusTypes } from '../authentication-types';

export const SalesforceLayout = ({
  integrationStatus,
  children,
}: {
  integrationStatus?: IntegrationStatusTypes;
  children: ReactNode;
}) => {
  const { integrationId } = useParams<SalesforceIntegrationId>();
  const title = useTranslation('settings.integrations.sf.title');
  const description = useTranslation('settings.integrations.sf.description');

  return (
    <Page>
      <IntegrationHeader
        title={title}
        icon={<SalesforceLogo />}
        subText={description}
        tabs={
          <NavigationTabs
            integrationStatus={integrationStatus}
            integrationId={integrationId}
          />
        }
      />
      <PageContent>{children}</PageContent>
    </Page>
  );
};
